import { useMemo } from "react";
import { useSelector } from "react-redux";

import { ApplicationState } from "@/store";

export const usePriceRemarkFilterState = () => {
  const filterState = useSelector(
    (state: ApplicationState) => state.priceRemarkFilter,
  );
  return useMemo(() => filterState, [filterState]);
};
